

















































































import Component from 'vue-class-component';
import PluginComponent from '../PluginComponent';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import EventBus, { EVENTS } from '@/services/EventBus';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { extend } from 'ol/extent';
import { fromExtent } from 'ol/geom/Polygon';
import { Feature } from 'ol';

Chart.plugins.register(ChartDataLabels);

@Component({
  props: {},
  components: {},
})
export default class ChartsPlugin extends PluginComponent {
  static ID = 'ChartsPlugin';

  selectedProductType = '';

  selectedWoodSpecies = '';

  selectedCompany = '';

  selectedIdPlot="";

  isLoading = false;

  productTypes = [
    { value: '', text: 'Select a Product Type' },
  ];

  woodSpecies = [
    { value: '', text: 'Select a Sub Product' },
  ];

  companies = [
    { value: '', text: 'Select an Enterprise' },
  ];

  filteredData: any[] = [];

  woodSpeciesData: any[] = [];

  chartInstances: Chart[] = [];
  
  selectedFeature= false;

  soldDatas=[];

  harvestedDatas=[];

  showFilters=true;

  unitPrice=-1;

  priceInfoUnit="";

  area=0;

  created(){
    this.fetchDatas();
  }

  resetSearch(){
    this.selectedCompany='';
    this.selectedProductType='';
    this.selectedWoodSpecies='';
    this.updateCharts();
  }
  mounted() {
    EventBus.$on(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    EventBus.$on(EVENTS.SELECT_NO_FEATURE, this.cleanSelection);
    
    if(!this.selectedFeature){
      this.filteredData = [];
      //this.updateCharts();
    }

    const selectedFeatures = this.getMapService().selectionService.selectedFeature;
    if (selectedFeatures !== undefined) {
      this.onFeatureSelected(selectedFeatures);
    }
  }
  getDistinctValues(list:any):any[] {
    const distinct=list.filter((item:any, i:any, ar:any) => ar.indexOf(item) === i);; // to get distinct values
    return distinct;
  }
  closePanel(){
    this.getMapService().selectionService.cleanSelection();
    this.getMapService().selectionService.selectFeatures([],false,false);//selectedFeature=null;
  }

  async fetchDatas() {
    let url = window.location.href.split("/maps")[0];
    // let url="https://moldsilva.poc.onegeosuite.fr";
    const urlSolde = `${url}/geoserver/neogeo/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=neogeo:sold_view&outputFormat=json`;//&propertyName=sum
    const urlHarvested = `${url}/geoserver/neogeo/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=neogeo:harvested_view&outputFormat=json`;//&propertyName=sum

    try {
      this.isLoading = true;
      const responseSolde = await fetch(urlSolde);
      const responseHarvested = await fetch(urlHarvested);
      const dataSolde = await responseSolde.json();
      const dataHarvested = await responseHarvested.json();

      const productSolde = dataSolde.features;
      const productHarvested = dataHarvested.features;

      let companies=this.getDistinctValues(productSolde.map((x:any)=>x.properties.company_name));
      companies.forEach((companyName:any)=>{
        this.companies.push({ value: companyName, text: companyName });
      });
      let product_types=this.getDistinctValues(productSolde.map((x:any)=>x.properties.product_type));
      product_types.forEach((product_type:any)=>{
        this.productTypes.push({ value: product_type, text: product_type });
      });
      let species=this.getDistinctValues(productSolde.map((x:any)=>x.properties.species_product));
      species.filter(x=>x!='').forEach((specie:any)=>{
        this.woodSpecies.push({ value: specie, text: specie });
      });

      this.soldDatas=productSolde;
      this.harvestedDatas=productHarvested;
      this.updateCharts();
      this.isLoading = false;
    } catch (error) {
      console.error(`Erreur lors de la récupération des données :`, error);
    }
  }


  

  beforeDestroy() {
    this.chartInstances.forEach(chart => chart.destroy());
  }
  onFeatureSelected(features: any) {
    console.log(features);
    this.showFilters=false;
    this.selectedFeature = true;
    let idPlot=features[0].get('id_plot');
    this.selectedIdPlot=idPlot;
    this.filteredData = [];
    this.unitPrice=-1;
    let company="";
    let productType="";
    let species="";

    // graphs for Roundwood,Firewood and NTFP
    let firewoodH=this.filterDatas(company,species,productType,idPlot,this.harvestedDatas.filter((x:any)=>x.properties.product_type=="Firewood"));
    let roundWoodH=this.filterDatas(company,species,productType,idPlot,this.harvestedDatas.filter((x:any)=>x.properties.product_type=="Roundwood"));
    let ntfpH=this.filterDatas(company,species,productType,idPlot,this.harvestedDatas.filter((x:any)=>x.properties.product_type=="Non timber"));
    let firewoodS=this.filterDatas(company,species,productType,idPlot,this.soldDatas.filter((x:any)=>x.properties.product_type=="Firewood"));
    let roundWoodS=this.filterDatas(company,species,productType,idPlot,this.soldDatas.filter((x:any)=>x.properties.product_type=="Roundwood"));
    let ntfpS=this.filterDatas(company,species,productType,idPlot,this.soldDatas.filter((x:any)=>x.properties.product_type=="Non timber"));

    //console.log(firewoodH);
    this.area=this.filterDatas(company,species,productType,idPlot,this.harvestedDatas)[0].properties.area_ha;

    this.computeChartData("Firewood",company,species,firewoodS,firewoodH);
    this.computeChartData("Roundwood",company,species,roundWoodS,roundWoodH);
    this.computeChartData("Non timber",company,species,ntfpS,ntfpH);

    this.renderCharts();

  }

  cleanSelection(){
    this.showFilters=true;
    this.selectedFeature=false;
    this.updateCharts();
  }
  
  async updateCharts() {
    this.filteredData = [];
    
    let company=this.selectedCompany;
    let productType=this.selectedProductType;
    let species=this.selectedWoodSpecies;

    let allDatasToDisplay=this.filterDatas(company,species,productType,"",this.harvestedDatas);
    let plotIds=this.getDistinctValues(allDatasToDisplay.map((x:any)=>x.properties.id_plot));
    console.log(plotIds);
    let layerSource=this.getMapService().getLayersByLayerName("neogeo:plots")?.getLayerSource();
    console.log(layerSource);
    let extent:any;
    layerSource.forEachFeature((feature:any)=>{
      //to be used with custom style using display property
      if(plotIds.indexOf(feature.get('id_plot'))>=0 ||plotIds.indexOf(parseInt(feature.get('id_plot')))>=0){
        feature.set('display',"true");
        //console.log(feature.getGeometry().computeExtent(feature.getGeometry().getExtent()));
        if(extent){
          extent=extend(extent,feature.getGeometry().computeExtent(feature.getGeometry().getExtent()))
        }
        else{
          extent=feature.getGeometry().computeExtent(feature.getGeometry().getExtent());
        }
      }
      else{
        feature.set('display',"false");
      }
    });
    if(extent){
        this.getMapService().zoomToExtent(extent);
    }
    else{
      console.error("no extent")
    }
    
    
    // graphs for Roundwood,Firewood and NTFP
    let firewoodH=this.filterDatas(company,species,productType,"",this.harvestedDatas.filter((x:any)=>x.properties.product_type=="Firewood"));
    let roundWoodH=this.filterDatas(company,species,productType,"",this.harvestedDatas.filter((x:any)=>x.properties.product_type=="Roundwood"));
    let ntfpH=this.filterDatas(company,species,productType,"",this.harvestedDatas.filter((x:any)=>x.properties.product_type=="Non timber"));
    let firewoodS=this.filterDatas(company,species,productType,"",this.soldDatas.filter((x:any)=>x.properties.product_type=="Firewood"));
    let roundWoodS=this.filterDatas(company,species,productType,"",this.soldDatas.filter((x:any)=>x.properties.product_type=="Roundwood"));
    let ntfpS=this.filterDatas(company,species,productType,"",this.soldDatas.filter((x:any)=>x.properties.product_type=="Non timber"));
    

    this.computeChartData("Firewood",company,species,firewoodS,firewoodH);
    this.computeChartData("Roundwood",company,species,roundWoodS,roundWoodH);
    this.computeChartData("Non timber",company,species,ntfpS,ntfpH);
    this.renderCharts();

    // AFFICHAGE DU PRIX
    this.unitPrice=-1;
    if(this.selectedCompany && this.selectedCompany!="" && 
      this.selectedProductType && this.selectedProductType!="" && 
      this.selectedWoodSpecies && this.selectedWoodSpecies!="" && this.selectedFeature==false
    ){
      let pricePerUnit=0;
      let dataToUse:any;


      if(this.selectedProductType=="Firewood"){
        dataToUse=firewoodS;
        this.priceInfoUnit = 'stere';
      }
      else if(this.selectedProductType=="Roundwood"){
        dataToUse=roundWoodS;
        this.priceInfoUnit = 'm³';
      }
      else if(this.selectedProductType=="Non timber"){
        dataToUse=ntfpS;
        this.priceInfoUnit = 'kg';
      }
      if(dataToUse){
        pricePerUnit=dataToUse[0].properties.price_per_unit;
        //const productSold = Math.round(dataToUse.reduce((acc: any, feature: any) => acc + (feature.properties.sum || 0), 0));
        this.unitPrice=pricePerUnit;
      }


    }
  }
  
  filterDatas(company:any,species:any,productType:any,idPlot:any,data:any){
    if(company && company!="")
        data=data.filter((x:any)=>x.properties.company_name==company);

    if(species && species!="")
      data=data.filter((x:any)=>x.properties.species_product==species);

    if(productType && productType!="")
      data=data.filter((x:any)=>x.properties.product_type==productType);
    
      if(idPlot && idPlot!="")
      data=data.filter((x:any)=>x.properties.id_plot==idPlot);
    
    return data;
  }

  computeChartData(productType:string,company:string,species:string,dataSolde:any,dataHarvested:any){
    const productSolde = Math.round(dataSolde.reduce((acc: any, feature: any) => acc + (feature.properties.sum || 0), 0));
    const productHarvested = Math.round(dataHarvested.reduce((acc: any, feature: any) => acc + (feature.properties.sum || 0), 0));


    const productSoldDepot = Math.round(dataSolde.filter((x:any)=>x.properties.id_location==2).reduce((acc: any, feature: any) => acc + (feature.properties.sum || 0), 0));
    const productHarvestedDepot = Math.round(dataHarvested.filter((x:any)=>x.properties.id_location==2).reduce((acc: any, feature: any) => acc + (feature.properties.sum || 0), 0));
    const productSoldParcel = Math.round(dataSolde.filter((x:any)=>x.properties.id_location==1).reduce((acc: any, feature: any) => acc + (feature.properties.sum || 0), 0));
    const productHarvestedParcel = Math.round(dataHarvested.filter((x:any)=>x.properties.id_location==1).reduce((acc: any, feature: any) => acc + (feature.properties.sum || 0), 0));
    const productSoldRoadSide = Math.round(dataSolde.filter((x:any)=>x.properties.id_location==3).reduce((acc: any, feature: any) => acc + (feature.properties.sum || 0), 0));
    const productHarvestedRoadSide = Math.round(dataHarvested.filter((x:any)=>x.properties.id_location==3).reduce((acc: any, feature: any) => acc + (feature.properties.sum || 0), 0));


      if (productHarvested === 0) {
        return;
      }

      const remaining = Math.round(productHarvested - productSolde);
      const remainingDepot = Math.round(productHarvestedDepot - productSoldDepot);
      const remainingParcel = Math.round(productHarvestedParcel - productSoldParcel);
      const remainingRoadSide = Math.round(productHarvestedRoadSide - productSoldRoadSide);
      let unit = '';
      if (productType === 'Firewood') {
        unit = 'steres';
      } else if (productType === 'Roundwood') {
        unit = 'm³';
      } else if (productType === 'Non timber') {
        unit = 'kg';
      }

      const title = `${productType ? productType : ""}   ${company ? company : ""} ${species ? species : ""} (${unit})` || "Selected Data";


      // Group By species
      const productStat = dataSolde.reduce((acc: any, item: any) => {
        const species = item.properties.species_product;

        if (!acc[species]) {
          acc[species] = { title: species || "", solde: 0, remaining: 0, harvested: 0 };
        }
        acc[species].solde += Math.round(item.properties.sum);
        return acc;
      }, {} as Record<string, { title: string; solde: number; remaining: number; harvested: number }>);
      dataHarvested.reduce((acc: any, item: any) => {
        const species = item.properties.species_product;

        if (!productStat[species]) {
          productStat[species] = { title: species || "", solde: 0, remaining: 0, harvested: 0 };
        }
        productStat[species].harvested += Math.round(item.properties.sum);
        
        return acc;
      }, {} as Record<string, { title: string; solde: number; remaining: number; harvested: number }>);


      const productStatsList = Object.values(productStat);
     
      console.log(productStatsList);
      productStatsList.forEach((x:any)=>x.remaining=x.harvested-x.solde);

      if (productType === 'Non timber') {
        console.log('title', productType, title)
        this.filteredData.push({
          title: title,
          solde: productSolde,
          remainingDepot,
          unit:unit,
          harvested: Math.round(productSolde + remainingDepot),
          bySpecies:productStatsList
        });
      }else{
        this.filteredData.push({
          title: title,
          solde: productSolde,
          remaining,
          remainingDepot,
          remainingParcel,
          remainingRoadSide,
          unit:unit,
          harvested: productHarvested,
          bySpecies:productStatsList
        });
      }

  }
  renderCharts() {
    this.chartInstances.forEach(chart => chart.destroy());
    this.chartInstances = [];

    this.$nextTick(() => {
      this.filteredData.forEach((item, index) => {
        const graphDiv:any = this.$refs[`graphElement${index}`] as HTMLCanvasElement;
        if (graphDiv) {
          if(this.selectedFeature)
            graphDiv[0].height = 250;
          else
          graphDiv[0].height=120;
          let backgroundColor = ['#244500', '#8ebd3e', '#8ebd00', '#8ebd88'];
          const chartInstance = new Chart(graphDiv, {
            type: 'doughnut',
            data: {
              labels: item.title === 'Non timber     (kg)' ? ['Sold', 'Remaining (Depot)'] : ['Sold', 'Remaining (Depot)', 'Remaining (Parcel)', 'Remaining (RoadSide)'],
              datasets: [
                {
                  label: item.title,
                  data: [item.solde, item.remainingDepot,item.remainingParcel,item.remainingRoadSide],
                  backgroundColor: backgroundColor ,
                  borderWidth: 1,
                },
              ],
            },
            options: {
              responsive: true,
              legend:{
                  reverse:true,
                },
              plugins: {
                datalabels: {
                  color: '#fff',
                  textShadowColor:'#000',
                  textShadowBlur:5,
                  textStrokeWidth:1,
                  textStrokeColor:'#000',
                  //backgroundColor:'#ffffff',
                  anchor: 'center',
                  align: 'center',
                  font: { weight: 'bold' },
                  formatter: (value: any) => value,
                },
              },
            },
          });
          this.chartInstances.push(chartInstance);

        }

        if (this.selectedFeature) {
            const speciesGraphDiv:any = this.$refs[`woodSpeciesGraph${index}`] as HTMLCanvasElement;
            const data = item.bySpecies;
  
            if (speciesGraphDiv && data.length >= 1) {
              speciesGraphDiv[0].height = 300
              const labels = data.map((species: any) => species.title);  
              const soldeData = data.map((species: any) => species.solde || 0);
              const remainingData = data.map((species: any) => species.remaining || 0);
              const harvestedData = data.map((species: any) => species.harvested || 0);
  
              const speciesChartInstance = new Chart(speciesGraphDiv, {
                type: 'horizontalBar',
                data: {
                  labels,
                  datasets: [
                    {
                      label: 'Sold',
                      data: soldeData,
                      backgroundColor: '#244500',
                      categoryPercentage: 0.9,
                      barPercentage: 0.7,
                    },
                    {
                      label: 'Remaining',
                      data: remainingData,
                      backgroundColor: '#8ebd3e',
                      categoryPercentage: 0.9,
                      barPercentage: 0.7,
                    },
                    {
                      label: 'Harvested',
                      data: harvestedData,
                      backgroundColor: 'rgb(128,128,128)',
                      categoryPercentage: 0.9,
                      barPercentage: 0.7,
  
                    },
                  ],
                },
                options: {
                  responsive: true,
                  layout: {
                    padding: {
                    },
                  },
                  scales: {
                    xAxes: [{
                      ticks: {
                        // padding: 5, 
                        // beginAtZero: true,
                      },
                    }],
                    yAxes: [{
                      ticks: {
                        // lineHeight: 0.5,
                        // padding: 10,
                      },
                    }],
                  },
                  plugins: {
                    datalabels: {
                      color: '#fff',
                      textShadowColor:'#000',
                      textShadowBlur:5,
                      textStrokeWidth:1,
                      textStrokeColor:'#000',
                      anchor: 'end',
                      align: 'center',
                      font: {
                        weight: 'bold',
                      },
                      formatter: (value: any) => value,
                    },
                  },
                  legend: {
                    display: true,
                    position: 'top',
                    labels: {
                      boxWidth: 20,
                      padding: 10,
                    },
                  },
                  title: {
                    display: true,
                    text: "by species",
                    position: 'bottom',
                    // font: {
                    //   size: 16,
                    //   weight: 'bold',
                    // },
                  },
                },
              });
  
              this.chartInstances.push(speciesChartInstance);
            }
        }
      });
    });
}
}
